export const errorStrings = {
  min: "Too few characters entered.",
  max: "Too many characters entered.",
  required: "This is a required field.",
  email: "Invalid email address.",
  commentMax: "Please shorten your comment to 500 characters or less.",
};
